import { Pipe, PipeTransform, Input, Directive } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  @Input('length') length = 60;
  constructor() { }

  transform(value: string, args?: number): any {
    if (args && value.length > args) {
      return `${value.substr(0, args)}...`;
    } else if (!args && value.length > this.length) {
      return `${value.substr(0, this.length)}...`;
    } else {
      return value;
    }
  }

}
